import { Shutdown } from '@app/models/types/Shutdown';

export function formatAuthor(shutdown: Pick<Shutdown, 'createdBy'>) {
  if (!shutdown.createdBy) {
    return 'Inconnu';
  }

  return `${shutdown.createdBy.firstname} ${shutdown.createdBy.lastname}`;
}
